<template>
    <section class="tables">
        <vue-snotify></vue-snotify>

        <!-- modal to view template start-->
        <b-modal id="webinar-scheduler" hide-footer>
            <template #modal-title>
                Email Template
            </template>
            <div class="d-block">
                <div class="title">
                    <h5>
                        From the <span class=" text-primary">DC Trainings Team:</span> A reminder, regarding this week's
                        Webinar
                    </h5>
                    <p> The title of this week's Webinar is <span class=" text-primary">{{ webinarData.WeekName }}</span>
                    </p>
                    <div v-if="webinarData.IsScottAbsent == 1">
                        This week's Webinar is pre-recorded.
                    </div>
                </div>

                <div class="datetime border p-2 d-flex justify-content-around">
                    <div class="date d-flex">
                        <div class="date-img">
                            <img src="@/assets/images/clendar-icon.png" alt="">
                        </div>
                        <div class="date-text">
                            <h5 class="bold">DATE:</h5>
                            <p>{{ WebinarDate }}</p>
                        </div>
                    </div>
                    <div class="time d-flex">
                        <div class="time-img">
                            <img src="@/assets/images/time.png" alt="">
                        </div>
                        <div class="time-text">
                            <h5 class="bold">Time:</h5>
                            <p>{{ WebinarTime }}</p>
                        </div>
                    </div>
                </div>
                <div class="link-joining mt-3">
                    <div v-if="webinarData.IsScottAbsent == 1">
                        This week's Webinar is viewable, beginning at 11:00am, {{ WebinarDate }} .
                        <br />To view this week's Webinar, click on the Webinars page: <a href="#">DC Trainings Webinar</a>
                    </div>
                    <div v-else>
                        Join us by clicking the link on the Webinars page: <a href="#">DC Trainings Webinar</a>
                    </div>
                </div>
                <div class="great mt-3">
                    <h4 class="bold">Thank you,</h4>
                    <p> The DC Trainings Team</p>
                </div>
            </div>
            <b-button class="mt-3" block @click="$bvModal.hide('webinar-scheduler')">Close
                Me</b-button>
        </b-modal>
        <!-- modal to view template end-->

        <div class="row mt-5">
            <div class="col-md-12 d-flex align-items-stretch grid-margin">
                <div class="row flex-grow">
                    <div class="col-12 grid-margin">
                        <div class="card">
                            <div class="card-header">
                                <h4 class="card-title">Content Mangement</h4>
                            </div>
                            <div class="card-body">
                                <form action="" method="post" @submit.prevent="getWebinarScheduleById">
                                    <div class="row">
                                        <div class="col-md-12 mb-3">
                                            <div class="row">
                                                <div class="col-md-12 btn alert alert-danger"
                                                    style="text-align: left; padding: 15px; "
                                                    v-show="alertMessage == 'alert'">
                                                    <strong> Alert! Please set Scheduler for this Topic. </strong>
                                                </div>
                                                <div class="col-md-12 btn alert alert-danger"
                                                    style="text-align: left; padding: 15px; "
                                                    v-show="alertMessage == 'expire'">
                                                    <strong> This Scheduler Expired </strong>
                                                </div>

                                                <div class="col-md-12 btn alert alert-info"
                                                    style="text-align: left; padding: 15px; "
                                                    v-show="alertMessage == 'run'">
                                                    <strong>This Topic Scheduler will be run from {{ webinarData.StartDate
                                                    }}
                                                        PDT to
                                                        {{ webinarData.StopDate }} </strong>
                                                </div>
                                                <div class="col-md-12 btn alert alert-warning"
                                                    style="text-align: left; padding: 15px; "
                                                    v-show="alertMessage == 'resume'">
                                                    <strong> This Topic Scheduler Stoped and it will be not run on untill
                                                        you resume. </strong>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-5 col-sm-6">
                                            <div role="group" class="form-group">
                                                <label for="webinarID" class="d-block">Select Webinar</label>
                                                <div>
                                                    <select class="custom-select" id="webinarID" v-model="webinarParams.id"
                                                        required name="GroupID">
                                                        <option value="">Select Week</option>
                                                        <option v-for="(web, index) in webinarOptions" :key="index"
                                                            :value="web.WebinarID">
                                                            Week {{ web.WeekNumber }} - {{ web.WeekName }} - {{
                                                                formatDate(web.WebinarDate) }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-5 col-sm-6">
                                            <button class="btn btn-success mt-4">Select Webinar</button>
                                        </div>
                                    </div>
                                </form>
                                <br>
                                <section v-if="displaySection">
                                    <form action="" method="post" @submit.prevent="updateWebinarinfo">
                                        <div class="row">
                                            <div class="col-md-4">
                                                <h5>Email Send to Group's</h5>
                                                <div class="form-check-inline">
                                                    <input class="form-check-input" type="checkbox"
                                                        v-model="webinarData.GroupIDList" id="Futures1" value="1">
                                                    <label for="Futures1">Futures1</label>
                                                </div>

                                                <div class=" form-check-inline">
                                                    <input class="form-check-input" type="checkbox"
                                                        v-model="webinarData.GroupIDList" id="Futures2" value="2">
                                                    <label for="Futures2">Futures2 </label>
                                                </div>
                                                <div class=" form-check-inline">
                                                    <input class="form-check-input" type="checkbox"
                                                        v-model="webinarData.GroupIDList" id="Currents" value="11">
                                                    <label for="Currents">Currents </label>
                                                </div>
                                                <div class=" form-check-inline">
                                                    <input class="form-check-input" type="checkbox"
                                                        v-model="webinarData.GroupIDList" id="Pasts" value="0">
                                                    <label for="Pasts">Pasts </label>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div role="group" class="form-group">
                                                    <label for="sendingDate" class="d-block">Email sending Date</label>
                                                    <div>
                                                        <input id="sendingDate" type="date" v-model="webinarData.StartDate"
                                                            class="form-control">
                                                        <!-- @change="setDate($event)" -->
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div>
                                                    <label for="SendTime">Send Time</label>&nbsp;&nbsp;
                                                    <input type="time" v-model="webinarData.SendTime">
                                                    <!-- <vue-timepicker v-model="webinarData.SendTime" format="hh:mm A"></vue-timepicker> -->
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div role="group" class="form-group">
                                                    <label for="webinarID" class="d-block">Action scheduler</label>
                                                    <div>
                                                        <select class="custom-select" id="webinarID"
                                                            v-if="webinarData.SchedulerStatus == null"
                                                            v-model="webinarData.SchedulerStatus" required name="GroupID">
                                                            <option value="">Select Group </option>
                                                            <option value="update">update</option>
                                                        </select>
                                                        <select class="custom-select" id="webinarID"
                                                            v-else-if="webinarData.SchedulerStatus == 'pause'"
                                                            v-model="webinarData.SchedulerStatus" required name="GroupID">
                                                            <option value="">Select Group </option>
                                                            <option value="pause">pause</option>
                                                            <option value="resume">resume</option>
                                                        </select>
                                                        <select class="custom-select" id="webinarID" v-else
                                                            v-model="webinarData.SchedulerStatus" required name="GroupID">
                                                            <option value="">Select Group</option>
                                                            <option value="update">update</option>
                                                            <option value="pause">pause</option>
                                                            <option value="resume">resume</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-4 pt-3">
                                                <input type="submit" class="btn btn-primary" name="submit"
                                                    value="Update Scheduler">
                                                <button type="button" class="btn btn-primary ml-3"
                                                    @click="$bvModal.show('webinar-scheduler');">Email Preview</button>
                                            </div>
                                        </div>
                                    </form>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<style>
#webinar-scheduler .modal-dialog {
    max-width: 657px;
}
</style>
<script>
import Vue from "vue";
import API from '@/api'
import moment from 'moment'

export default {
    name: 'webinar',
    data() {
        return {
            displaySection: false,
            alertMessage: "",
            WebinarDate: '',
            WebinarTime: "",
            SendTime: "",
            webinarParams: {
                id: ""
            },
            StartDate: "",

            webinarOptions: {},
            webinarData: {
                GroupIDList: [],
                SchedulerStatus: ""
            },
        };
    },
    mounted() {
        this.getWebinarSchedule();
    },
    methods: {
        setDate(date) {
            this.webinarData.StartDate = date.target.value;
        },
        alertMessageFun() {
            let SendTimeCheck = moment(this.webinarData.SendTime, 'hh:mm A').format('HH:mm');
            let StopDate = new Date(this.webinarData.StopDate + "T" + SendTimeCheck);
            let StartDate = new Date(this.webinarData.StartDate + "T" + SendTimeCheck);
            let NowDate = new Date();
            if (NowDate < StopDate && this.webinarData.SchedulerStatus == 'pause') {
                this.alertMessage = 'run';
            } else if (NowDate < StartDate && this.webinarData.SchedulerStatus == 'pause') {
                this.alertMessage = 'resume';
            } else if (this.webinarData.SchedulerStatus == '' || this.webinarData.SchedulerStatus == null) {
                this.alertMessage = 'alert';
            } else {
                this.alertMessage = 'expire';
            }
            // console.log(this.webinarData)
            // console.log(SendTimeCheck, " => -----", StartDate, StopDate, NowDate);
        },
        getWebinarSchedule() {
            API.getWebinarSchedule(this.getWebinarScheduleCB, this.errorCB);
        },
        getWebinarScheduleCB(res) {
            this.$showNotification(res, "success")
            this.webinarOptions = res.data
        },
        getWebinarScheduleById() {
            API.getWebinarScheduleById(this.webinarParams, this.getWebinarScheduleByIdCB, this.errorCB)
            this.setDateAndTime();
        },
        getWebinarScheduleByIdCB(res) {
            this.webinarData = { ...res.data, ...{ GroupIDList: [] } };
            this.displaySection = true
      
            this.webinarData.SendTime = moment.utc(this.webinarData.SendTime, 'hh:mm A').format('HH:mm');
            this.webinarData.StartDate = moment(this.webinarData.StartDate).format('yyyy-MM-D') 
            this.alertMessageFun();
        },
        updateWebinarinfo() {
            this.webinarData.StartDate = moment(this.webinarData.StartDate).format('MM/DD/Y')
            this.webinarData.SendTime = moment.utc(this.webinarData.SendTime, 'hh:mm').format('hh:mm A');
            this.webinarParams.id = '';
            this.alertMessage = '';
            API.updateWebinarinfo({ ...this.webinarData },
                this.$showNotification({ message: 'Updated Successfully' }, "success"),
                this.errorCB);
        },
        setDateAndTime() { 
            this.WebinarDate = moment(this.webinarData.WebinarDate).format('dddd, MMMM Do, YYYY');
            this.WebinarTime = moment(this.webinarData.WebinarDate).format('hh:mm A'); 
        },
        errorCB(err) {
            console.log(err);
            this.$showNotification({ message: 'Failed system error' }, "error")
        },
        formatDate(value) {
            if (value) {
                return moment(String(value)).format('MMM DD, yyyy')
            }
        },
    }, components: {},
}
</script>
<style>
@media (max-width: 575px) {
    .btn-success.mt-4 {
        margin-top: 0 !important;
    }
}
</style>
